// Helpers shared by the Available Puppies page and the header's litter menu.

// Litters render in `displayOrder` (lowest first) so the order on the page can
// be changed from the data file alone. Anything without one keeps its position
// in the array and falls to the end, so the field is optional.
export function byDisplayOrder(litters) {
  return litters
    .map((litter, index) => ({ litter, index }))
    .sort((a, b) => {
      const orderA = a.litter.displayOrder ?? Infinity;
      const orderB = b.litter.displayOrder ?? Infinity;
      return orderA - orderB || a.index - b.index;
    })
    .map(({ litter }) => litter);
}

// The id the litter's section carries on the page, and the target the header
// menu links to. Namespaced so it cannot collide with any other anchor.
export function litterAnchorId(litter) {
  return `litter-${litter.id}`;
}

// One menu entry per litter, in page order. Titles read "Cookie & Dume Litter"
// on the page, but the word repeats down a menu, so drop it there; a litter can
// override the whole label with `navLabel`.
export function litterNavItems(litters) {
  return byDisplayOrder(litters).map(litter => ({
    id: litter.id,
    label: litter.navLabel || litter.title.replace(/\s+Litter$/, ''),
    to: `/puppies#${litterAnchorId(litter)}`
  }));
}
